import { selector } from 'recoil'
import sessionStorage from './sessionStorage'

export const isDuPodUserCheck = selector({
  key: 'IsDuPodUser',
  get: ({ get }) => get(sessionStorage)?.user?.email?.endsWith('@dupod.com') ?? false,
})
